import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_HIDE_EMAIL_TRACKING_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_HIDE_EMAIL_TRACKING_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/OpenHideEmailTrackingModal')
};